









































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import report from '@/components/data/report.vue';
import moment from 'moment';
import { voteOverviewColumns } from '@/utils/report';
import request from '@/assets/js/http';
import { reportList } from '@/api/report';
import downloadStreamFile from '@/assets/js/downloadStreamFile';
import { mapGetters } from 'vuex';

const url = '/projectVote/getICSummary';
const downloadUrl = '/projectVote/downloadICSummary';

@Component({
  components: { report },
  computed: { ...mapGetters(['userInfo']) }
})
class VoteOverviewReport extends Vue {
  userInfo: any;
  projectName: string = '';
  currency: number = 0;
  url: string = url;
  endTime: string = '';
  startTime: string = '';
  downloadUrl: string = downloadUrl;
  fileName: string = '';
  columns: any[] = voteOverviewColumns;
  industry: string = '';
  projectNameTmp: string = '';
  hasPermission: boolean = false;
  currencyList: any[] = [
    {
      name: '全部币种',
      value: 0
    },
    {
      name: '人民币',
      value: 1
    },
    {
      name: '美元',
      value: 2
    },
    {
      name: '人民币及美元',
      value: 3
    }
  ];
  loading: boolean = false;
  data: any = {};
  data_ceo_meeting: any = {};
  data_ts: any = {};
  data_jg: any = {};
  data_other: any = {};

  onTabChange(key) {
    console.log(key);
  }

  get requestData() {
    const { startTime, endTime } = this;
    let data = {
      startTime,
      endTime
    };
    for (let key in data) {
      if (!data[key]) {
        delete data[key];
      }
    }
    return data;
  }

  created() {
    // let tmp = test234.name;
    this.getList();
    this.getPermission();
  }

  mounted() {
    let date = moment(new Date()).format('YYYYMMDD');
    this.fileName = `Vote统计数据报表_${date}`;
  }

  handleSearch(val) {
    this.projectName = val;
  }

  onChange(date, dateString) {
    this.endTime = date
      ? moment(date)
        .endOf('d')
        .format('YYYY-MM-DD HH:mm:ss')
      : '';
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
    this.getList();
  }

  startOnChange(date, dateString) {
    this.startTime = date
      ? moment(date)
        .startOf('d')
        .format('YYYY-MM-DD HH:mm:ss')
      : '';
    if (this.projectNameTmp !== this.projectName) {
      this.projectName = this.projectNameTmp;
    }
    this.getList();
  }

  async getList(flag = false) {
    try {
      this.loading = true;
      let data = { ...this.requestData };

      let res;
      res = await request({
        url: this.url,
        method: 'post',
        data
      });
      this.loading = false;
      if (res.code === 200) {
        this.data = res.data;
        this.data_ceo_meeting = res.data['CEO Meeting'];
        this.data_ts = res.data['TS vote'];
        this.data_jg = res.data['交割vote'];
        this.data_other = res.data['其它vote'];
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getPermission() {
    try {
      let res = await reportList();
      if (res.code === 200) {
        const exportList = res.data.filter(_ => _.id === 7)[0].export.map(_ => _.id);
        const { id } = this.userInfo || {};
        this.hasPermission = exportList.indexOf(id) > -1;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async exportReport() {
    try {
      let date = moment(new Date()).format('YYYYMMDD');
      downloadStreamFile(downloadUrl, this.requestData, `Vote统计数据报表_${date}`);
    } catch (err) {
      console.log(err);
    }
  }
}
export default VoteOverviewReport;
